var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 2.58824C6.80203 2.58824 2.58824 6.80203 2.58824 12C2.58824 17.198 6.80203 21.4118 12 21.4118C17.198 21.4118 21.4118 17.198 21.4118 12C21.4118 6.80203 17.198 2.58824 12 2.58824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 2.58824C6.80203 2.58824 2.58824 6.80203 2.58824 12C2.58824 17.198 6.80203 21.4118 12 21.4118C17.198 21.4118 21.4118 17.198 21.4118 12C21.4118 6.80203 17.198 2.58824 12 2.58824Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12.7292 12 13.3542 11.7396 13.875 11.2188C14.3958 10.6979 14.6562 10.0677 14.6562 9.32812C14.6562 8.58854 14.3958 7.95833 13.875 7.4375C13.3542 6.91667 12.7292 6.65625 12 6.65625C11.2708 6.65625 10.6458 6.91667 10.125 7.4375C9.60417 7.95833 9.34375 8.58854 9.34375 9.32812C9.34375 10.0677 9.60417 10.6979 10.125 11.2188C10.6458 11.7396 11.2708 12 12 12ZM17.3438 17.3438V16C17.3438 15.5208 17.1042 15.0781 16.625 14.6719C16.1458 14.2656 15.4948 13.9427 14.6719 13.7031C13.849 13.4635 12.9583 13.3438 12 13.3438C11.0417 13.3438 10.151 13.4635 9.32812 13.7031C8.50521 13.9427 7.85417 14.2656 7.375 14.6719C6.89583 15.0781 6.65625 15.5208 6.65625 16V17.3438H17.3438Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.f58ae933eaec5e048f8f2192c2c5cc76.svg";
export { ForwardRef as ReactComponent };